import { render, staticRenderFns } from "./PanelUploadTable.vue?vue&type=template&id=0ec2d559&scoped=true&"
import script from "./PanelUploadTable.vue?vue&type=script&lang=js&"
export * from "./PanelUploadTable.vue?vue&type=script&lang=js&"
import style0 from "./PanelUploadTable.vue?vue&type=style&index=0&id=0ec2d559&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec2d559",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec2d559')) {
      api.createRecord('0ec2d559', component.options)
    } else {
      api.reload('0ec2d559', component.options)
    }
    module.hot.accept("./PanelUploadTable.vue?vue&type=template&id=0ec2d559&scoped=true&", function () {
      api.rerender('0ec2d559', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/PanelUploadTable.vue"
export default component.exports